//------------- COMPONENT NAVIGATOR ---------

//gerencia qual pagina está atualemnte sendo exibida no portal

//importações
import React from "react";
import { useState } from "react";

import MenuHeader from "../menu-header";
import MenuLateral from "../menu-lateral";

const MenuNavigator = ({token, view, page}) => {
    //recebe a página
    const [pageContent, setPageContent] = useState(page);
    console.log(pageContent);

    //exibe os componentes da página recebi
    return (
        <div className="div-body-home">
            <div className="div-lateral-home">
                <MenuLateral page={pageContent} setPage={setPageContent}></MenuLateral>
            </div>
            <div className="div-content-home">
                <MenuHeader token={token}></MenuHeader>
                <div className="div-page-content-home">{view}</div>
            </div>
        </div>
    );
};

export default MenuNavigator;
